import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, IconButton } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import { makeStyles } from '@material-ui/styles';
import Avatar from '@mui/material/Avatar';
import ProductItem from './../../component/ProductItem/index'
import FooterBar from './../../component/FooterAtom/index'
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import GppGoodRoundedIcon from '@mui/icons-material/GppGoodRounded';
import Drawer from '@material-ui/core/Drawer';
import MobileBrowserMarketDrawer from './../../pages/Mobile_Browser_Market1/Mobile_Browser_Market1'
import firebase from "../../config/firebase/index";
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import { fontSize, fontWeight } from '@mui/system';
import ReactGA from "react-ga";
import encSecret from '../../config/encryption/index.js';
import NoFollowMeta from '../../component/NofollowMeta/index.jsx';
import { Accordion, AccordionDetails, AccordionSummary, Button } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PublicDeals from '../../component/PublicDealsAtom/index.jsx';
import TextArea from 'antd/lib/input/TextArea';
import RatingFB from '../../component/RatingAtom/index.jsx';
import Suggest_Bid from '../Suggest_Bid/Suggest_Bid.js';
import Login from '../login/Login.js';
import DialogItemAtom from '../../component/DialogItemAtom/index.jsx';
import SuggestTable from '../../component/SuggestTable/index.jsx';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import MessageAtom from '../../component/MessagAtom/index.jsx';

var CryptoJS = require("crypto-js");



const Mobile_Browser = (props) => {

    const classes = useStyles();
    const history = useHistory();
    const params = useParams();

    const [PhoneNo, setPhoneNo] = useState("");
    const [name, setName] = useState("");
    const [cname, setCname] = useState("");
    const [image, setImage] = useState("");
    const [dateTime, setDateTime] = useState("");
    const [productImg, setProductImg] = useState("");
    const [productName, setProductName] = useState("");
    const [min, setMinPrice] = useState("");
    const [max, setMaxPrice] = useState("");
    const [place, setPlace] = useState("");
    const [quantity, setQuantity] = useState("");
    const [quantityUnit, setQuantityUnit] = useState("");
    const [message, setMessage] = useState("");
    const [isDealer, setIsDealer] = useState("");
    const user = JSON.parse(localStorage.getItem("user"));
    const [methodFlag, setMethodFlag] = useState("call");
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    const [view, setView] = useState(0);
    const [call, setCall] = useState(0);
    const [text, setText] = useState(0);
    const [load, setLoad] = useState(false);
    const [open, setOpen] = useState(false);
    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [link, setLink] = useState("");
    const [productDate, setProductDate] = useState(new Date());
    const phoneLink = "tel:" + PhoneNo
    const whatsAppLink = "https://wa.me/91" + PhoneNo;
    const [show, setShow] = useState(true);
    const [error, setError] = useState(false);
    const [number, setNumber] = useState("");
    const [feedback, setFeedback] = useState("");
    const [shareLink, setShareLink] = useState("");
    const [inter, setInter] = useState("");
    const [pDeals, setPDeals] = useState(false);
    const [pview, setPview] = useState(false);
    const [isPublic, setIsPublic] = useState(false);
    const [rating, setRating] = useState(0);
    const [date, setDate] = useState(new Date());
    const [openDialog, setOpenDialog] = useState(false);


    function SimpleDialog(props) {
        const { onClose, selectedValue, open } = props;

        const handleClose = () => {
            onClose(false);
        };

        return (
            <Dialog onClose={handleClose} open={open}>
                <DialogTitle>Disclaimer</DialogTitle>
                <Box ml={2} mr={2} mb={2}>
                    <Typography style={{ textAlign: "justify", wordSpacing: "-2px" }}>
                        The platform provides information for reference purposes and users are advised to exercise their discretion to check and verify the information provided on the platform independently. The company specifically states that it is not liable to any of its users financially or legally for any activity causing harm or financial/ commercial loss due to reliance placed on the information provided on the platform.
                    </Typography>
                </Box>
            </Dialog>
        );
    }


    let count = 0;

    // console.log("Params ::: ", params[0]);
    let dealId;
    if (params && params[0] && params[0].length != 20) {
        let dealtext = params[0];
        dealId = dealtext.slice(-20);
    }
    else
        dealId = params.dealId;
    // console.log("DEAL ID ::: ", dealId);
    const dealViewed = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const deal = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }


    const dealViewerRegOnDeals = (category, action, label) => {
        console.log("GA event:", category, ":", action, ":", label);
        ReactGA.event({
            category: category,
            action: action,
            label: label,
        })
    }

    const dealerFlag = () => {
        if (isLoggedIn) {
            setIsDealer(user[0].dealerFlag);
        }
        else {
            setIsDealer("");
        }
    }

    const formatMonthDate = (num) => {
        return parseInt(num) > 9 ? num : "0" + num;
    }

    const createdAt = () => {
        const today = new Date();
        const date = today.getFullYear() + '-' + formatMonthDate(today.getMonth() + 1) + '-' + formatMonthDate(today.getDate());
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

        const dateTime = date + ' ' + time;

        return dateTime;
    }

    const Product = async () => {
        if (dealId) {
            firebase.database().ref(`Product/${dealId}`).on('value', deal => {
                const oldDeal = deal.val()
                setView(parseInt(oldDeal.analytics.views) + 1)
                setCall(parseInt(oldDeal.analytics.phone))
                setText(parseInt(oldDeal.analytics.whatsapp))
                setQuantity(oldDeal.Quantity)
                setMessage(oldDeal.Message)
                setQuantityUnit(oldDeal.QuantityUnit)
                setProductName(oldDeal.productName)
                setProductImg(oldDeal.image)
                setName(CryptoJS.AES.decrypt(oldDeal.DealerName, encSecret.key).toString(CryptoJS.enc.Utf8))
                setPhoneNo(oldDeal.DealerNumber)
                setImage(oldDeal.DealerImage)
                setDateTime(formatDate(oldDeal.createdAt))
                setPlace(oldDeal.Place)
                setMaxPrice(CryptoJS.AES.decrypt(oldDeal.Max, encSecret.key).toString(CryptoJS.enc.Utf8))
                setMinPrice(CryptoJS.AES.decrypt(oldDeal.Min, encSecret.key).toString(CryptoJS.enc.Utf8))
                setProductDate(oldDeal.createdAt)
                setShareLink(oldDeal.shareLink)
                setIsPublic(oldDeal.isPublic ? oldDeal.isPublic : false);
                setLoad(true);

            })
        }
    }

    const handleClickOpen = () => {
        setOpen1(true);
    };

    const handleClose = () => {
        setOpen1(false);

    };
    const handleAClose = () => {
        setOpen1(false);
        clearInterval(inter);
    };

    const handleASubmit = () => {
        console.log(number, feedback)
        if (!cname || cname.length == 0 || !number || number.length == 0 || !feedback || feedback.length == 0)
            setError(true);
        else {
            console.log(dealId);
            if (dealId) {
                const fbRef = firebase.database().ref('feedback').push({
                    number: number,
                    cname: cname,
                    feedbackText: feedback,
                    createdAt: new Date().toISOString(),
                    dealId: dealId,
                    productName: productName,
                    productUrl: shareLink,
                    dealerName: CryptoJS.AES.encrypt(name, encSecret.key).toString(),
                    dealerNumber: PhoneNo,
                    userAgent: `${window.navigator.userAgent}`
                })
            }
            setOpen1(false);
        }
    }



    const handleSubmit = () => {
        console.log(number, feedback)
        if (!cname || cname.length == 0 || !number || number.length == 0 || !feedback || feedback.length == 0)
            setError(true);
        else {
            console.log(dealId);
            if (dealId) {
                firebase.database().ref("Feedback").once("value", snapshot => {
                    const val = snapshot.val();
                    console.log(val);
                    const feedbackRef = firebase.database().ref("Feedback");
                    const feed = {
                        number: number,
                        cname: cname,
                        feedbackText: feedback,
                        createdAt: new Date().toISOString(),
                        dealId: dealId,
                        productName: productName,
                        productUrl: shareLink,
                        dealerName: CryptoJS.AES.encrypt(name, encSecret.key).toString(),
                        dealerNumber: PhoneNo,
                        userAgent: `${window.navigator.userAgent}`,
                        rating: rating,
                        type: "dealers"
                    };
                    feedbackRef.push(feed);

                });

            }
        }

    }

    const formatDate = (DATE) => {
        let d = DATE.split(" ");
        let dd = d[0].split("-");
        let newDATE = dd[1] + "/" + dd[2] + "/" + dd[0] + " " + d[1];
        console.log("NDATE ::: ", newDATE);
        let nDate = new Date(newDATE);

        console.log("::: :", nDate);
        let dateArr = nDate.toString().split(" ");
        let hrs = nDate.getHours();
        let mnts = nDate.getMinutes();
        let AMPM = hrs >= 12 ? 'PM' : 'AM';
        hrs = hrs % 12;
        hrs = hrs ? hrs : 12;
        mnts = mnts < 10 ? '0' + mnts : mnts;
        var result = dateArr[2] + " " + dateArr[1] + " " + hrs + ':' + mnts + ' ' + AMPM;
        return result;
        // return nDate.toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: 'numeric', hour12: true })
    }

    const showDeal = async () => {
        const currentDate = new Date();
        const createdDate = new Date(productDate.replace(/-/g, "/"));
        // console.log(typeof(productDate), productDate, createdDate);
        // console.log(createdDate.getFullYear(), currentDate.getFullYear());
        // console.log(createdDate.getDate(), currentDate.getDate());
        // console.log(createdDate.getMonth() +1, currentDate.getMonth()+1 );
        // console.log(formatMonthDate(currentDate.getMonth()+1));
        if ((formatMonthDate(currentDate.getDate()) === formatMonthDate(createdDate.getDate())) && (formatMonthDate(currentDate.getMonth()) === formatMonthDate(createdDate.getMonth())) && (currentDate.getFullYear() === createdDate.getFullYear())) {
            setShow(true);
        } else {
            setShow(false)
        }
    }

    const createCustomer = async () => {
        const customerRef = firebase.database().ref('Customer');
        const customer = {
            DealId: dealId,
            Name: user[0].Name,
            PhoneNo: user[0].PhoneNo,
            img: user[0].img,
            method: "call",
            time: createdAt()
        };

        customerRef.push(customer);
    };

    const createCustomer1 = async () => {
        const customerRef = firebase.database().ref('Customer');
        const customer = {
            DealId: dealId,
            Name: user[0].Name,
            PhoneNo: user[0].PhoneNo,
            img: user[0].img,
            method: "whatsapp",
            time: createdAt()
        };

        customerRef.push(customer);
    };

    const NoOfCalls = () => {
        firebase.database().ref(`Product/${dealId}/analytics/phone`).set(call + 1);
        createCustomer();

    }

    const NoOfWhatsapp = async () => {
        firebase.database().ref(`Product/${dealId}/analytics/whatsapp`).set(text + 1)
        createCustomer1();
    }


    const setPublicDeals = () => {
        let dealsArr = [];
        firebase.database().ref("Product").orderByChild("isPublic")
            .equalTo(true).on("value", snapshot => {
                console.log(":::: ", snapshot.val());
                console.log("Public Count ::: ", snapshot.val().length)
                let dealsData = snapshot.val();
                dealsArr = [];
                for (const key in dealsData) {
                    const dealObj = {
                        id: key,
                        ...dealsData[key],
                    };
                    // NoOfViews(dealObj);
                    dealsArr.push(dealObj);
                }
                setPDeals(dealsArr);
            });
    }

    // if deal is expired

    useEffect(() => {
        showDeal();
    }, [productDate])


    // while mounting the component
    useEffect(() => {
        Product();
        dealerFlag();
        setPublicDeals()
    }, []);

    // for counting number of views
    useEffect(() => {
        let count = JSON.parse(localStorage.getItem(dealId));
        if (load && count === null) {
            firebase.database().ref(`Product/${dealId}/analytics/views`).set(view);
            count = count + 1;
        }
        localStorage.setItem(dealId, JSON.stringify(count));

        setLoad(!load)
    }, [view]);

    const logIn = () => {
        history.push("/");
    };


    const profile = () => {
        history.push("/profile");
    }

    // const [state, setState] = React.useState({
    //     bottom: false,
    // });

    const setAppRating = (val) => {
        console.log("Rating :: ", val);
        setRating(val);
    }

    const toggleDrawer = (method) => {
        console.log(method);
        setOpen(!open);
        if (method === "call") {
            const phoneLink = "tel:" + PhoneNo;
            setLink(phoneLink);
            setMethodFlag(method);
        } else {
            const whatsAppLink = "https://wa.me/91" + PhoneNo;
            setLink(whatsAppLink);
            setMethodFlag(method);
        }

    };


    return (
        <>
            {dealId && isPublic == false ? <NoFollowMeta /> : <></>}
            <Grid p={2} className={classes.commonSectionBuild}>
                <Box className={classes.headerBrowser}>
                    <Box>
                        <Typography variant="h6" style={{ fontWeight: 600 }} >
                            सौदेबाज़ी
                        </Typography><br />
                        <Typography style={{ fontWeight: 400, marginTop: "-20px", fontSize: 12 }}>
                            सुरक्षित और निजी
                        </Typography>
                    </Box>

                    {isLoggedIn ?
                        <Box style={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography style={{ border: "1px solid white", borderRadius: 50, width: "40px", textAlign: "center" }} onClick={profile}>
                                <PersonIcon fontSize="large" />
                            </Typography>

                        </Box> :
                        <Box style={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography style={{ fontWeight: 500, padding: "10px 5px 0 0", textDecoration: "underline" }} onClick={logIn} >
                                लॉगिन करे
                            </Typography>
                            <Typography style={{ border: "1px solid white", borderRadius: 50, width: "40px", textAlign: "center" }} onClick={logIn}>
                                <PersonIcon fontSize="large" />
                            </Typography>
                        </Box>

                    }
                </Box>
                <div style={{ display: (dealId && show) ? "block" : "none" }}>
                    <Box className={classes.kishanDetail} >
                        <Box className={classes.textCenterSet}>
                            <Box mr={1}>
                                <Avatar alt="Remy Sharp" src={image} />
                            </Box>
                            <Typography variant="body1">
                                <span style={{ fontWeight: 600 }}>{name}</span><br />
                                <span style={{ fontWeight: 500, fontSize: 12 }}>{dateTime}</span>
                            </Typography>
                        </Box>
                        <Box className={classes.textCenterSet}>
                            {/* <Box ml={1} className={classes.rotateSHareIcon}>
                                <GppGoodRoundedIcon />
                            </Box> */}
                            {isLoggedIn ?
                                <a href={whatsAppLink} style={{ textDecoration: 'none' }}>
                                    <Typography variant="body1" >
                                        <WhatsAppIcon onClick={() => { NoOfWhatsapp(); deal('Deal', 'Click', 'WhatsApp') }} style={{ background: "green", color: "white", borderRadius: 50, fontSize: "230%" }} />
                                    </Typography>
                                </a>
                                :
                                <Typography variant="body1" >
                                    <WhatsAppIcon onClick={() => { toggleDrawer("whatsapp"); deal('Deal', 'Click', 'WhatsApp') }} style={{ background: "green", color: "white", borderRadius: 50, fontSize: "230%" }} />
                                </Typography>
                            }

                        </Box>
                    </Box>
                    <ProductItem image={productImg} productName={productName} minPrice={min} maxPrice={max} place={place} quantity={quantity} quantityUnit={quantityUnit} isPublic={isPublic} />
                    <Box style={{ padding: "0px 30% 15px 30%", textAlign: "center", marginTop: "10px" }}>

                        <Button
                            // name="बोली दर्ज करें"
                            onClick={() => {
                                // toggleDrawer("suggest")
                                setOpen1(true);
                                setDate(new Date());
                            }}
                            style={{
                                borderRadius: "5px",
                                boxShadow: "0 3px 6px 0 rgba(255, 255, 255, 0.58)",
                                border: "solid 1px #53252f",
                                backgroundColor: "#53252f",
                                color: "white",
                                padding: "5px 20px",
                                fontSize: 16
                            }}
                        >
                            {/* बोली दर्ज करें */}
                            बेहतर भाव
                        </Button>
                        <DialogItemAtom
                            open={open1}
                            onClose={handleClose}
                            PhoneNo={PhoneNo} closePopUp={setOpen} link={link} methodFlag={"suggest"} dealId={dealId} quantityUnit={quantityUnit} loggedIn={isLoggedIn ? true : false}
                            selectedDeal={dealId} date={date}
                        />

                    </Box>
                    <Box style={{ padding: "5px 20px" }}>
                        <MessageAtom message={message} len={46} />
                        {dealId ?
                            <Box mt={1}>
                                <SuggestTable id={dealId} />
                            </Box>
                            : <></>
                        }
                    </Box>


                    {/* <Box className={classes.contetnArrange}> */}
                    {/* {isLoggedIn ?
                            <Box mr={1} fullwidth>
                                <a href={phoneLink} style={{ textDecoration: 'none' }}>
                                    <ButtonAtom
                                        startIcon={<CallIcon />}
                                        name="कॉल करे "
                                        onClick={() => { NoOfCalls(); deal('Deal', 'Click', 'Phone call'); }}

                                    /></a>
                            </Box> :
                            <Box mr={1} fullwidth>
                                <ButtonAtom
                                    startIcon={<CallIcon />}
                                    name="कॉल करे "
                                    onClick={() => { clearInterval(inter); toggleDrawer("call"); deal('Deal', 'Click', 'Phone call'); }}
                                    style={{ textDecoration: 'none' }}
                                />

                            </Box>
                        } */}
                    {/* <Box ml={1} fullwidth>
                            <Button
                                variant={"outlined"}
                                onClick={() => { toggleDrawer("suggest") }}
                                style={{ border: "1px solid #53252f", color: "#53252f", padding: "6px 15px", fontSize: "120%", width: "100%" }}
                            >
                                बोली दर्ज करें
                            </Button>
                        </Box> */}
                    {/* </Box> */}
                    <Box mb={2} ml={2} mr={2}>
                        <Typography variant="body1" style={{ fontSize: 12 }} onClick={() => { setOpenDialog(true) }}>
                            {/* * सभी भाव आज रात 12 बजे तक है */}
                            * Click here to read the platform advisory.
                        </Typography>
                    </Box>
                    <Box className={`${classes.contetnArrange} ${classes.manageIconCenter}`}>
                        <KeyboardDoubleArrowDownIcon />
                    </Box>
                </div>
                {/* <div style={{ display: !dealId && !isDealer ? "block" : "none" }} className={classes.dealerCall}>
                    <Typography style={{ fontWeight: 600, fontSize: 20 }}>अगर आप डीलर बनना चाहते हैं तो कृपया 8696965308 पर कॉल करें।</Typography>
                </div> */}

                <div style={{ display: dealId && !show ? "block" : "none" }} className={classes.dealerCall}>
                    <Typography style={{ fontWeight: 600, fontSize: 18 }}>यह सौदा अब सक्रिय नहीं है।</Typography>
                </div>
                {pDeals && !dealId ? <PublicDeals deals={pDeals} /> : ''}
                {/* <div style={{ display: !dealId ? "block" : "none", width: "auto", position: "fixed", bottom: 70 }}>
                    <Accordion style={{}}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            onClick={() => setPview(true)}
                        >
                            <Typography style={{ fontWeight: 600, fontSize: 18, color: '#53252f' }}>सार्वजनिक सौदे देखने के लिए क्लिक करें</Typography>
                        </AccordionSummary>
                        <AccordionDetails style={{ padding: 0 }}>
                            {(pDeals && pview) ? <PublicDeals deals={pDeals} /> : ''}

                        </AccordionDetails>
                    </Accordion>
                </div> */}

                {/* <div>
                    <Typography style={{ fontWeight: 600, fontSize: 18, position: 'absolute', bottom: 100, right: 20, textDecoration: 'underline', color: '#53252f' }} onClick={() => setShowPublic(true)}>सार्वजनिक सौदे देखने के लिए क्लिक करें</Typography>
                    <div style={{ display: showPublic ? "block" : "none" }}>
                        <Box className={classes.kishanDetail} >
                            <Box className={classes.textCenterSet}>
                                <Box mr={1}>
                                    <Avatar alt="Remy Sharp" src={image} />
                                </Box>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>
                                    {name}<br />{dateTime}
                                </Typography>
                            </Box>
                            <Box className={classes.textCenterSet}>
                                <Box ml={1} className={classes.rotateSHareIcon}>
                                    <GppGoodRoundedIcon />
                                </Box>
                                <Typography variant="body1">
                                    निजी सौदा
                                </Typography>

                            </Box>
                        </Box>
                        <ProductItem image={productImg} productName={productName} minPrice={min} maxPrice={max} place={place} quantity={quantity} quantityUnit={quantityUnit} />
                        <Box p={2}>
                            <Typography variant="body1" >
                                {message}
                            </Typography>
                        </Box>
                        <Box className={classes.contetnArrange}>
                            {isLoggedIn ?
                                <Box mr={1} fullwidth>
                                    <a href={phoneLink} style={{ textDecoration: 'none' }}>
                                        <ButtonAtom
                                            startIcon={<CallIcon />}
                                            name="कॉल करे "
                                            onClick={() => { NoOfCalls(); deal('Deal', 'Click', 'Phone call'); }}

                                        /></a>
                                </Box> :
                                <Box mr={1} fullwidth>
                                    <ButtonAtom
                                        startIcon={<CallIcon />}
                                        name="कॉल करे "
                                        onClick={() => { toggleDrawer("call"); deal('Deal', 'Click', 'Phone call'); }}
                                        style={{ textDecoration: 'none' }}
                                    />

                                </Box>}
                            {isLoggedIn ?
                                <Box ml={1} fullwidth>
                                    <a href={whatsAppLink} style={{ textDecoration: 'none' }}>
                                        <ButtonAtom
                                            startIcon={<WhatsAppIcon />}
                                            name="व्हाट्सप्प करे"
                                            cclass="whatsUpBtn"
                                            onClick={() => { NoOfWhatsapp(); deal('Deal', 'Click', 'WhatsApp') }}
                                            style={{ textDecoration: 'none' }}
                                        /></a>
                                </Box> :
                                <Box ml={1} fullwidth>
                                    <ButtonAtom
                                        startIcon={<WhatsAppIcon />}
                                        name="व्हाट्सप्प करे"
                                        cclass="whatsUpBtn"
                                        onClick={() => { toggleDrawer("whatsapp"); deal('Deal', 'Click', 'WhatsApp') }}
                                        style={{ textDecoration: 'none' }}
                                    />
                                </Box>}
                        </Box>
                    </div>
                </div> */}

                {/* <Box>
                    <FooterBar />
                </Box> */}
                {methodFlag == "suggest" ?
                    <div >
                        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                            <Suggest_Bid PhoneNo={PhoneNo} closePopUp={setOpen} link={link} methodFlag={methodFlag} dealId={dealId} quantityUnit={quantityUnit} loggedIn={isLoggedIn ? true : false} />
                        </Drawer>
                    </div>
                    :
                    <div >
                        <Drawer className={classes.drawerDesign} anchor={'bottom'} open={open}>
                            <MobileBrowserMarketDrawer PhoneNo={PhoneNo} closePopUp={setOpen} link={link} methodFlag={methodFlag} dealId={dealId} quantityUnit={quantityUnit} loggedIn={isLoggedIn ? true : false} />
                        </Drawer>
                    </div>
                }

                <Box>
                    <FooterBar className={classes.footerFixed} isDealer={isDealer} active={[1, 0, 0, 0]} />
                </Box>
            </Grid>
            <div id="recaptcha-container"></div>
            <SimpleDialog
                open={openDialog}
                onClose={() => setOpenDialog(!openDialog)}
            />
        </>
    )
};


const useStyles = makeStyles(() => ({
    drawerDesign: {
        '& .MuiDrawer-paper': {
            paddingTop: 20,
            margin: "auto",
            maxWidth: 540,
            borderRadius: '20px 20px 0 0',
        }
    },
    headerBrowser: {
        background: '#53252f',
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    kishanDetail: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '10px 20px',
        boxSizing: 'border-box',
        alignItems: 'center',
    },
    textCenterSet: {
        display: 'flex',
        alignItems: 'center',
    },
    rotateSHareIcon: {
        transform: 'rotateY(360deg)',
    },
    contetnArrange: {
        width: '100%',
        padding: '10px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxSizing: 'border-box',
        '& div': {
            width: '100%'
        }
    },
    commonSectionBuild: {
        maxWidth: 540,
        float: 'none',
        margin: '0 auto'
    },
    manageIconCenter: {
        justifyContent: 'center',
        padding: '50px 0 20px',
        boxSizing: 'border-box',
    },
    image: {
        width: '35px',
        height: '35px',
        borderRadius: '50%',
        position: 'relative',
        overflow: 'hidden',
    },
    footerFixed: {
        position: 'fixed',
    },
    dealerCall: {
        width: '55%',
        padding: '10px 20px',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginTop: '200px',
        marginLeft: '60px',
    },
}));

export default Mobile_Browser;